import { Outlet, createRootRoute } from '@tanstack/react-router'
import SiteHeader from '@/components/layout/SiteHeader'
import SiteFooter from '@/components/layout/SiteFooter'

const rootRoute = createRootRoute({
  component: () => (
    <div
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      <SiteHeader />
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <div className="oumma-fade" style={{ flex: 1 }}>
          <Outlet />
        </div>
      </main>
      <SiteFooter />
    </div>
  ),
})

export default rootRoute
